import {
    ApplicationConfig,
    ErrorHandler,
    importProvidersFrom,
    isDevMode,
    LOCALE_ID
} from '@angular/core';
import {
    provideRouter,
    RouteReuseStrategy,
    withHashLocation
} from '@angular/router';
import {
    provideHttpClient,
    withInterceptorsFromDi
} from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app-routing.module';
import { environment } from '../environments/environment';
import { HttpInterceptorProviders } from './services/interceptors/index';
import { BaseGoogleApiLoader } from './core/abstractions/base.google-api-loader';
import { AsyncCallbackGoogleApiLoader } from './core/utils/map-loaders/async-callback.google-api-loader';
import { GlobalErrorHandler } from './services/interceptors/global-error-handler';
import { CustomRouteReuseStrategy } from './core/utils/CustomRouteReuseStrategy';
import { IgxExcelExporterService } from '@infragistics/igniteui-angular';
import { BrowserModule, HammerModule } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(BrowserModule, HammerModule),
        provideRouter(routes, withHashLocation()),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideToastr(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        { provide: LOCALE_ID, useValue: 'de-DE' },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
        {
            provide: BaseGoogleApiLoader,
            useClass: AsyncCallbackGoogleApiLoader
        },
        IgxExcelExporterService,
        HttpInterceptorProviders
    ]
};
